module.exports = __webpack_public_path__ + "img/RECUADRO_Capacitació_XS.9dde9433.png";